module.exports = __webpack_public_path__ + "static/media/IMG_7567.52533909.jpg";